import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BigDeal } from './services/festival-deal.service';

@Injectable()
export class AppConfigService {
  private  APP_CONFIG: {MAGIC_CHECKOUT_ENABLED:boolean |undefined};
  private BIG_DEAL: BigDeal[]=[];
  constructor (private injector: Injector) { }
    loadAppConfig() {
        let http = this.injector.get(HttpClient);
        return http.get(environment.BASE_URL + "/magic-checkout-env")
        .toPromise()
        .then((data:{MAGIC_CHECKOUT_ENABLED:boolean|undefined}) => {
          if(data==null){
            this.APP_CONFIG = {MAGIC_CHECKOUT_ENABLED:null}
          }
          else{
            this.APP_CONFIG = data;
          }
           
        }).catch(err=> {this.APP_CONFIG = {MAGIC_CHECKOUT_ENABLED:null} })
    }

    loadBigDeal(){
      let http = this.injector.get(HttpClient);
      return http.get(environment.BASE_URL + "/big-deal").toPromise()
      .then((x:any[])=> {
        let bigDeals:BigDeal[] =[]
        x.forEach(element => {
        let u = {...element}
        if(element.from != undefined && element.from != null){
          u.start = element.from;
        }
        if(element.to != undefined && element.to != null){
          u.end = element.to;
        }
        if(u.color== undefined || u.color == null){
          u.color = 'linear-gradient(90deg, #8B0391 1.38%, #CB033C 29.44%, #FA0303 59.5%, #8B038D 97.59%)'
        }
        bigDeals.push(u)
      });
      this.BIG_DEAL = bigDeals;    
      return bigDeals;
      }).catch(err=> {console.log(err)})
    }

    get config() {
        return this.APP_CONFIG;
    }

    get bigDeal(){
      return this.BIG_DEAL;
    }
}
